module.exports = __webpack_public_path__ + "media/optimize-weights.b1c3084b.mp4";